import { registerDecorator } from 'class-validator';
/**
 * Custom validation decorator for class props that checks if a prop is boolean and true
 * Mostly used in form models that have checkboxes
 */
export function IsChecked(validationOptions) {
    return function (object, propertyName) {
        registerDecorator({
            name: 'isChecked',
            target: object.constructor,
            propertyName: propertyName,
            options: validationOptions,
            validator: {
                validate: function (value) {
                    return typeof value === 'boolean' && !!value;
                }
            }
        });
    };
}
